import { render } from "./Dashboard.vue?vue&type=template&id=ebc23362"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/home/Dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ebc23362"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ebc23362', __exports__)) {
    api.reload('ebc23362', __exports__)
  }
  
  module.hot.accept("./Dashboard.vue?vue&type=template&id=ebc23362", () => {
    api.rerender('ebc23362', render)
  })

}


export default __exports__